// Task status configuration with colors
export const TASK_STATUS_CONFIG = {
  'todo': {
    color: 'text-gray-600',
    bgColor: 'bg-gray-50',
    borderColor: 'border-gray-200',
    headerBg: 'bg-gray-100',
    headerText: 'text-gray-800',
    dotColor: 'bg-gray-500'
  },
  'inProgress': {
    color: 'text-blue-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    headerBg: 'bg-blue-100',
    headerText: 'text-blue-800',
    dotColor: 'bg-blue-500'
  },
  'done': {
    color: 'text-green-600',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
    headerBg: 'bg-green-100',
    headerText: 'text-green-800',
    dotColor: 'bg-green-500'
  },
  'cancelled': {
    color: 'text-red-600',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-200',
    headerBg: 'bg-red-100',
    headerText: 'text-red-800',
    dotColor: 'bg-red-500'
  }
};

// Kanban stages for tasks by status
export const TASK_STATUS_KANBAN_STAGES = [
  { id: 'todo', name: 'To Do' },
  { id: 'inProgress', name: 'In Progress' },
  { id: 'done', name: 'Done' },
  { id: 'cancelled', name: 'Cancelled' },
];

export interface KanbanTask {
  id: string;
  name: string;
  description?: string;
  status: 'todo' | 'inProgress' | 'done' | 'cancelled';
  priority: 'low' | 'medium' | 'high' | 'urgent';
  due_date?: string;
  assigned_to?: string;
  assignee?: {
    id: string;
    first_name: string;
    last_name: string;
  };
  created_at: string;
  updated_at: string;
}

export interface KanbanStage {
  id: string;
  name: string;
}
